/** Formatea segundos a "m:ss" (o "h:mm:ss" si supera la hora). */
export function fmtTime(seconds) {
  const s = Number(seconds);
  if (!Number.isFinite(s) || s < 0) return '--:--';
  const total = Math.round(s);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const ss = String(total % 60).padStart(2, '0');
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${ss}`;
  return `${m}:${ss}`;
}

/** Duracion de una pista: "—" si se desconoce (0/null). */
export function fmtDuration(seconds) {
  return Number(seconds) > 0 ? fmtTime(seconds) : '--:--';
}

/** Iniciales para avatares ("Ana Belén" → "AB"). */
export function initials(name = '') {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Hue determinista por id (para gradientes de carátula fallback). */
export function hueFromString(str = '') {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) % 360;
  return h;
}
